var _path, _path2, _path3, _path4, _path5, _g, _ellipse, _path6, _path7, _path8, _path9, _path10, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccounting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 20v167H0V24C0 8.95 8.95 0 20 0h312c11.05 0 20 8.95 20 20zM352 187v248c0 11.05-8.95 20-20 20H20c-11.05 0-20-8.95-20-16V187z",
    fill: "#50758d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 133V54c0-7.732 6.268-14 14-14h244c7.732 0 14 6.268 14 14v79c0 7.732-6.268 14-14 14H64c-7.732 0-14-6.268-14-14z",
    fill: "#2edffc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84 147H64c-7.73 0-14-6.27-14-14V54c0-7.73 6.27-14 14-14h20c-7.73 0-14 6.27-14 14v79c0 7.73 6.27 14 14 14z",
    fill: "#27bdf3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M321 241v80H185.5v-94H307c7.73 0 14 6.27 14 14zM185.5 227v94H50v-78c0-9.73 6.27-16 14-16zM185.5 321v94H64c-7.73 0-14-6.27-14-12v-82zM321 321v80c0 7.73-6.27 14-14 14H185.5v-94z",
    fill: "#f5f5f5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307 219.5H64c-12.257 0-21.5 10.103-21.5 23.5v160c0 10.388 10.047 19.5 21.5 19.5h243c11.855 0 21.5-9.645 21.5-21.5V241c0-11.855-9.645-21.5-21.5-21.5zm6.5 21.5v72.5H193v-79h114c3.584 0 6.5 2.916 6.5 6.5zm-256 2c0-5.084 2.612-8.5 6.5-8.5h114v79H57.5zm0 160v-74.5H178v79H64c-3.755 0-6.5-3.158-6.5-4.5zm256-2c0 3.584-2.916 6.5-6.5 6.5H193v-79h120.5z",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2b597f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 375.5H96c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h54c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5zM145 266.5h-14.5V252c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v14.5H101c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h14.5V296c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-14.5H145c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM259.107 274l10.253-10.253a7.5 7.5 0 00-10.607-10.607L248.5 263.393l-10.253-10.253a7.5 7.5 0 00-10.607 10.607L237.893 274l-10.253 10.253a7.5 7.5 0 1010.608 10.607l10.253-10.253 10.253 10.253c1.465 1.464 3.385 2.196 5.304 2.196s3.839-.732 5.304-2.196a7.5 7.5 0 000-10.607zM283 125.5h-14c-9.649 0-17.5-7.851-17.5-17.5V79c0-9.649 7.851-17.5 17.5-17.5h14c9.649 0 17.5 7.851 17.5 17.5v29c0 9.649-7.851 17.5-17.5 17.5zm-14-49a2.502 2.502 0 00-2.5 2.5v29c0 1.379 1.121 2.5 2.5 2.5h14c1.379 0 2.5-1.121 2.5-2.5V79c0-1.379-1.121-2.5-2.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 187v-22.5H35c-5.523 0-10-4.477-10-10V24C25 8.95 33.95 0 45 0H20C8.95 0 0 8.95 0 24v415c0 7.05 8.95 16 20 16h25c-11.05 0-20-8.95-20-16V197c0-5.523 4.477-10 10-10z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394,
    cy: 285,
    fill: "#fad207",
    rx: 103,
    ry: 23
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M497 426.75V474c0 15-46.11 23-103 23s-103-8-103-23v-47.25c0 15 46.11 23 103 23s103-8 103-23z",
    fill: "#fad207"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M497 379.5v47.25c0 15-46.11 23-103 23s-103-8-103-23V379.5c0 15 46.11 23 103 23s103-8 103-23z",
    fill: "#faa515"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M497 332.25v47.25c0 15-46.11 23-103 23s-103-8-103-23v-47.25c0 15 46.11 23 103 23s103-8 103-23z",
    fill: "#fad207"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M497 285v47.25c0 15-46.11 23-103 23s-103-8-103-23V285c0 15 46.11 23 103 23s103-8 103-23z",
    fill: "#faa515"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.646 392.646a7.5 7.5 0 01-5.304-12.803l34-34a7.5 7.5 0 0110.607 10.607l-34 34a7.477 7.477 0 01-5.303 2.196z",
    fill: "#2b597f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 349,
    fill: "#2b597f",
    r: 7.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 387,
    fill: "#2b597f",
    r: 7.5
  })));
}

export default __webpack_public_path__ + "3d04a6a86398f621265927c5f7dc10e0.svg";
export { SvgAccounting as ReactComponent };